module.exports = __webpack_public_path__ + "2084daff74ece4cfddef1abdf54287b3.svg";